import { Reducer } from "redux";

import { AgencyStore } from "../../../types/ReduxTypes/StoreTypes";
import { SET_ADVERTISERS, SET_AGENCY, SET_PLAYBOOKS, SET_SELECTED_ADVERTISER } from "./types";

const initialState: AgencyStore = {
  agencyId: "",
  users: [],
  createdBy: "",
  name: "",
  email: "",
  advertisers: [],
  playbooks: [],
  selectedAdvertiserId: null,
};

const agencyReducer: Reducer<AgencyStore> = (
  state = initialState,
  // eslint-disable-next-line no-shadow
  action,
) => {
  switch (action.type) {
    case SET_AGENCY:
      return {
        ...state,
        ...action.payload,
      };
    case SET_ADVERTISERS:
      return {
        ...state,
        advertisers: action.payload,
      };
    case SET_PLAYBOOKS:
      return {
        ...state,
        playbooks: action.payload,
      };
    case SET_SELECTED_ADVERTISER:
      return {
        ...state,
        selectedAdvertiserId: action.payload,
      };
    default:
      return state;
  }
};

export default agencyReducer;
